var _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.49 4.74A5.028 5.028 0 0 0 19.22.51a51.645 51.645 0 0 0-14.48 0A5.028 5.028 0 0 0 .51 4.78a51.644 51.644 0 0 0 0 14.48 5.028 5.028 0 0 0 4.27 4.23A51.34 51.34 0 0 0 12 24a51.8 51.8 0 0 0 7.26-.51 5.028 5.028 0 0 0 4.23-4.27A51.34 51.34 0 0 0 24 12a51.8 51.8 0 0 0-.51-7.26ZM19 14.816V19a1 1 0 0 1-2 0v-4.184a2.982 2.982 0 0 1 0-5.632V5a1 1 0 0 1 2 0v4.184a2.982 2.982 0 0 1 0 5.632ZM3 9a2.995 2.995 0 0 1 2-2.816V5a1 1 0 0 1 2 0v1.184a2.982 2.982 0 0 1 0 5.632V19a1 1 0 0 1-2 0v-7.184A2.995 2.995 0 0 1 3 9Zm6 8a2.995 2.995 0 0 1 2-2.816V5a1 1 0 0 1 2 0v9.184A2.995 2.995 0 1 1 9 17Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 9,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 12,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 17,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevels);
export default __webpack_public_path__ + "static/media/levels.62bb0b5c775841d986c0935ee25c845c.svg";
export { ForwardRef as ReactComponent };